import type { Edge, Node } from '@xyflow/react';

export enum MindmapNodeShape {
  Text = 'text',
  Square = 'square',
  Rounded = 'rounded',
  Circle = 'circle',
  Cloud = 'cloud',
  Hexagon = 'hexagon',
}

/** Output of the parser — stable tree, never mutates after parse */
export interface MindmapTreeNode {
  id: string;
  label: string;
  shape: MindmapNodeShape;
  children: MindmapTreeNode[];
  depth: number;
}

export interface ParsedMindmap {
  root: MindmapTreeNode;
}

/** Data attached to each React Flow node */
export interface MindmapNodeData {
  nodeId: string;
  label: string;
  shape: MindmapNodeShape;
  depth: number;
  childCount: number;
  isExpanded: boolean;
  isRoot: boolean;
  colorIndex: number;
  [key: string]: unknown;
}

/** Data attached to each React Flow edge */
export interface MindmapEdgeData {
  colorIndex: number;
  sourceDepth: number;
  [key: string]: unknown;
}

export type MindmapFlowNode = Node<MindmapNodeData, 'mindmapCard'>;
export type MindmapFlowEdge = Edge<MindmapEdgeData, 'mindmapCurve'>;
